/**
 * Utility condivise per gli allegati (template e newsletter) — §11.6.
 * Vincoli: tipi ammessi + max 10MB per file. Il nome del campo multipart è ATTACHMENT_FIELD.
 */

/** Estensioni ammesse (§11.6). */
export const ATTACH_ALLOWED = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];

/** Dimensione massima per file (10MB). */
export const ATTACH_MAX_BYTES = 10 * 1024 * 1024;

/** Nome del campo multipart atteso da POST .../attachments (da confermare col BE). */
export const ATTACHMENT_FIELD = 'file';

/** `accept` per l'input file. */
export const ATTACH_ACCEPT = ATTACH_ALLOWED.map((e) => `.${e}`).join(',');

/**
 * Valida un file: ritorna un messaggio d'errore o null se ok.
 * @param {File} file
 * @returns {string|null}
 */
export function validateAttachment(file) {
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  if (!ATTACH_ALLOWED.includes(ext)) return `"${file.name}": tipo non ammesso`;
  if (file.size > ATTACH_MAX_BYTES) return `"${file.name}": supera i 10MB`;
  return null;
}

/**
 * Divide una lista di file in validi/scartati (con messaggi).
 * @param {File[]} files
 * @returns {{ valid: File[], rejected: string[] }}
 */
export function partitionAttachments(files) {
  const valid = [];
  const rejected = [];
  files.forEach((file) => {
    const err = validateAttachment(file);
    if (err) rejected.push(err);
    else valid.push(file);
  });
  return { valid, rejected };
}

/** Formatta una dimensione in byte in stringa leggibile. */
export function formatFileSize(size) {
  if (size == null) return '';
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

/** Nome visualizzato di un allegato già caricato (shape difensivo). */
export function attachmentName(att) {
  return att.file_name ?? att.name ?? att.original_name ?? 'Allegato';
}

/** Costruisce il FormData per l'upload di un allegato. */
export function buildAttachmentFormData(file) {
  const formData = new FormData();
  formData.append(ATTACHMENT_FIELD, file);
  return formData;
}
